module.exports = __webpack_public_path__ + "img/apple-touch-icon-180x180.c43cd371.png";